import React, { useMemo } from 'react';
import { ROOT_NODE_ID } from '../../../dataViews/DynamicTree';
import MultiSelection from '../../../dataViews/NextTree/plugins/MultiSelection';
import BadgeTooltip from '../../../utils/BadgeTooltip';
import useLayoutDirection, { getMirroredSide, } from '../../../utils/Translations/useLayoutDirection';
import TreeSelectorTooltipContent from './TreeSelectorTooltipContent';
const MAX_DISPLAY_COUNT = 99;
export default function TreeSelectorTooltip(props) {
    const { direction, isLayoutRTL } = useLayoutDirection();
    const { syntheticRootNodeName, models = [], selection = null, loading = false, modelId, position = 'responsive', isRenderOnlySelected = false, isFormField = false, tooltipTreePlugins = [new MultiSelection()], renderTooltipContent = null, adapter = {}, plugins, iconClassName, tooltipClassName, } = props;
    const _models = useMemo(() => syntheticRootNodeName
        ? [
            {
                id: ROOT_NODE_ID,
                name: syntheticRootNodeName,
                parentId: null,
                status: 'ACTIVE',
            },
            ...models,
        ]
        : models, [syntheticRootNodeName, models]);
    const title = useMemo(() => {
        const title = Array.isArray(selection) ? selection.length : 1;
        if (title > MAX_DISPLAY_COUNT) {
            return `${MAX_DISPLAY_COUNT}+`;
        }
        return title;
    }, [selection]);
    const hasBoxSelectionVisuals = useMemo(() => tooltipTreePlugins.find(plugin => (plugin === null || plugin === void 0 ? void 0 : plugin.selectionVisuals) === 'box'), [tooltipTreePlugins]);
    if ((Array.isArray(selection) && !selection.length) || !selection) {
        return null;
    }
    const branchIcon = (Number(title) === 1 && 'tree6') || undefined;
    const tooltipPosition = getMirroredSide(position, isLayoutRTL);
    return (<BadgeTooltip icon={hasBoxSelectionVisuals ? 'eye' : branchIcon} iconClassName={iconClassName} modelId={modelId} offsetTop={-20} position={tooltipPosition} title={title} tooltipClassName={tooltipClassName}>
      <div data-layout-direction={direction} dir={direction}>
        {renderTooltipContent ? (renderTooltipContent()) : (<TreeSelectorTooltipContent adapter={adapter} hasSyntheticRootNode={!!syntheticRootNodeName} isFormField={isFormField} isRenderOnlySelected={isRenderOnlySelected || isFormField} loading={loading} models={_models} plugins={plugins} selection={selection}/>)}
      </div>
    </BadgeTooltip>);
}
